module.exports = __webpack_public_path__ + "static/media/delete-item.d8cbc512.svg";